// extracted by mini-css-extract-plugin
export default {"tags":"Tags_tags__WRRK3","tags__lista":"Tags_tags__lista__toFwO"};